export default {
  ai_explanation: {
    title: "Cum funcționează Estimator24",
    intro:
      "Estimator24 folosește inteligența artificială și analiza datelor pentru a determina valoarea corectă de piață a unui imobil pe baza a zeci de factori.",
    how_it_works: {
      title: "Cum se calculează prețul",
      step1: "Sistemul găsește apartamente similare într-un radius de până la 20 km.",
      step2: "Analizează caracteristici precum suprafața, etajul, anul construcției, vederea și infrastructura.",
      step3: "Mai multe modele de învățare automată calculează predicții independent.",
      step4: "Prețul final este o medie ponderată ajustată în funcție de tendințele pieței."
    },
    models: {
      title: "Modelele Estimator24",
      xgboost: "Model complex care analizează toți parametrii disponibili.",
      lightgbm: "Compară proprietatea cu altele similare din apropiere.",
      randomforest: "Identifică combinații rare de caracteristici și proprietăți subevaluate.",
      neural: "Rețea neuronală antrenată pe date istorice și fotografii ale proprietăților.",
      regression: "Model statistic care reflectă dinamica generală a pieței."
    },
    market: {
      title: "Ce înseamnă „sub” sau „peste piață”",
      desc: "Dacă prețul este sub media zonei, poate fi o achiziție avantajoasă. Dacă este peste, poate reflecta o stare mai bună, o vedere sau o locație premium. Estimator24 compară toți factorii pentru a arăta poziția reală pe piață."
    }
  }
}
